import * as React from "react";
import { forwardRef } from "react";
const SvgArrowForward = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 3.33334L8.82504 4.50834L13.475 9.16668H3.33337V10.8333H13.475L8.82504 15.4917L10 16.6667L16.6667 10L10 3.33334Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowForward);
export default ForwardRef;
